import script from "./BlackNamaMempelai.vue?vue&type=script&setup=true&lang=js"
export * from "./BlackNamaMempelai.vue?vue&type=script&setup=true&lang=js"

import "./BlackNamaMempelai.vue?vue&type=style&index=0&id=14910848&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14910848"]])

export default __exports__